export const newWorthy = {
  title: "New & Noteworthy",
  headers: ["", "Date Added"],
  data: [
    {
      name: "Charlie West Condos",
      type: "6:30 am",
      new: true
    },
    {
      name: "100 Victoria Tower 2",
      type: "6:30 am",
      new: true
    },
    {
      name: "Leslie Alexander",
      type: "6:30 am",
      new: true
    },
    {
      name: "Brooklyn Simmons",
      type: "6:30 am",
      tracking: true
    },
    {
      name: "MFD Fire Station No. 5	",
      type: "6:30 am",
      tracking: false
    }
  ]
};

export const constructionBid = {
  title: "Pre construction Bid Due",
  headers: ["", "Submited by"],
  data: [
    {
      name: "MFD Fire Station No. 5",
      type: "Nov 18"
    },
    {
      name: "100 Victoria Tower 2",
      type: "Tomorrow"
    },
    {
      name: "Leslie Alexander",
      type: "Dec 20"
    },
    {
      name: "Brooklyn Simmons",
      type: "Today"
    },
    {
      name: "Grand Bohemian Hotel",
      type: "Dec 15"
    }
  ]
};

export const recentUpdate = {
  title: "Recently Updated",
  headers: ["", "Date updated"],
  data: [
    {
      name: "MFD Fire Station No. 5",
      type: "6:30 am",
      new: true
    },
    {
      name: "100 Victoria Tower 2",
      type: "6:30 am",
      new: true
    },
    {
      name: "Leslie Alexander",
      type: "6:30 am"
    },
    {
      name: "Brooklyn Simmons",
      type: "6:30 am"
    },
    {
      name: "Grand Bohemian Hotel",
      type: "6:30 am"
    }
  ]
};
